import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0013cc05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-container" }
const _hoisted_2 = { class: "smaller-fields-container" }
const _hoisted_3 = {
  key: 0,
  class: "tab-container"
}
const _hoisted_4 = { class: "tab-container" }
const _hoisted_5 = { class: "smaller-fields-container" }

import ModalBase from "../ui/modals/modal-base.vue";
import { computed, ref, inject, watch, PropType } from "vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { Certificate } from "@/types/certificates/Certificate";
import PropertyLookup from "../ui/lookup/property-lookup.vue";
import ContactLookup from "../ui/lookup/contact-lookup.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import displayErrorMessage from "@/utils/ErrorHandling";
import lookupSingleSelect from "../ui/lookup/lookup-single-select.vue";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { CertificateTypes } from "@/types/certificates/CertificateTypes";
import { CertificateTypesValidation } from "@/enums/certificates/CertifcateTypesValidation";
import { PropertyData } from "@/types/properties/PropertyData";
import { CertificatesValidation } from "acquaint-api/validation/CertificatesValidation";
import AcquaintTextbox from "../ui/inputs/acquaint-textbox.vue";
import AcquaintDateBox from "../ui/inputs/acquaint-date-box.vue";
import { CodeType } from "acquaint-api/constants/CodeType";
import SystemCodeSingleSelect from "../ui/system-codes/system-code-single-select.vue";
import moment from "moment";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import AcquaintInfoBox from "../ui/inputs/acquaint-info-box.vue";
import { formatDate } from "bright-logic-core/src/format";
import { FieldSize } from "@/enums/system/FieldSize";
import { NewCertificateTab } from "@/enums/certificates/NewCertificateTab";
import { CertificateStatus } from "@/enums/certificates/CertificateStatus";
import { CertificateType } from "@/enums/certificates/CertificateType";
import { PropertyUsages } from "@/enums/properties/PropertyUsages";
import { CountryCode } from "bright-logic-core/src/CountryCode";
import EpcInputWrapper from "./epc-input-wrapper.vue";
import { SystemContactTypes } from "@/enums/contacts/SystemContactTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'base-certificate-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the certificate.
   * @type {number}
   * @default 0
   */
  certificateId: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the property.
   * @type {number}
   * @default 0
   */
  propertyId: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the contact.
   * @type {number}
   * @default 0
   */
  contactId: {
    type: Number,
    default: 0,
  },
  /**
   * This represents the certificates data being managed.
   * @type {Certificates}
   */
  certificateData: {
    type: Object as PropType<Certificate>,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /** Triggered when the modal is closed. This event notifies the parent component that the modal has been closed
   * and provides information about whether the certificate data was modified during the session.
   * @property {boolean} hasChanges - Indicates whether the certificate data was modified compared to its initial state.
   */
  "modalClosed",
],
  setup(__props, { emit }) {

const props = __props;





const showCertificateModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const enableFields = ref(false);
const certificateData = ref<Certificate>();
const initalCertificateData = ref<Certificate>();
const propertyData = ref<PropertyData>();
const showCloseConfirmation = ref(false);
const keepingModalOpening = ref(false);

watch(
  () => showCertificateModal.value,
  async () => {
    if (!showCertificateModal.value || keepingModalOpening.value) {
      return;
    }
    // This needs to be reset whenever the modal is opened to prevent some of the watches being triggered so that the data doesn't change unncessarily.
    certificateData.value = undefined;
    // initalCertificateData.value = undefined;
    enableFields.value = false;
    // Reset the selected tab back to general for better UX
    selectedTab.value = NewCertificateTab.General;

    await fetchIntialCertificateData();

    if (initalCertificateData.value) {
      // If this is opened from the certificates tab in a property's page, we must set the the property id
      // to be that of the property whose page the user is on.
      if (props.propertyId > 0) {
        initalCertificateData.value.propertyID = props.propertyId;
      }

      if (props.contactId > 0) {
        initalCertificateData.value.contactID = props.contactId;
      }

      // If we open the new certificate modal from a property page's certificates tab, we want to fetch the property and set the contact ID
      // here otherwise, the cancel confirmation will appear as the editable data will have the property's contact but not the initial data.
      if (props.propertyId > 0 && props.contactId == 0) {
        await setOriginalContactId(props.propertyId);
      }

      // I was getting a date error because some certificates don't have a start or end date, so I've added in this to prevent
      // the error from occuring. This probably isn't entirely necessary given that this is poor data and that users can't create
      // certificates without a start or end date so users shouldn't be able to get into this state anyway.
      initalCertificateData.value.startDate = initalCertificateData.value
        .startDate
        ? initalCertificateData.value.startDate
        : new Date().toISOString();
      initalCertificateData.value.endDate = initalCertificateData.value.endDate
        ? initalCertificateData.value.endDate
        : new Date().toISOString();

      if (props.certificateId > 0) {
        // We need to fetch the certificate type and update the end date as otherwise the end date for the editable ref thus casuing the save prompt to
        // be opened when it shouldn't be
        await fetchCertificateType(
          initalCertificateData.value.certificateTypeID,
        );

        setInitialEndDateByCertificateTypeDuration();
      }

      certificateData.value = JSON.parse(
        JSON.stringify(initalCertificateData.value),
      );
    }
  },
);

const fetchDefaultCertificates = async () => {
  try {
    initalCertificateData.value = await acquaintApiClient.httpGet(
      `database/certificates/defaultmodel`,
    );
  } catch (err) {
    enableFields.value = true;
    initalCertificateData.value = undefined;
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const fetchCertificateData = async () => {
  try {
    initalCertificateData.value = await acquaintApiClient.httpGet(
      `database/certificates/${props.certificateId}`,
    );
    return true;
  } catch (err) {
    enableFields.value = true;
    initalCertificateData.value = undefined;
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const fetchIntialCertificateData = async () => {
  if (props.certificateId) {
    return await fetchCertificateData();
  } else {
    return await fetchDefaultCertificates();
  }
};

const saveValidation = (e: any) => {
  if (!certificateTypeData.value) {
    displayErrorMessage(
      "We could not fetch the information for the certificate type to validate your new certificate.",
    );
    return false;
  }

  if (!certificateData.value?.certificateTypeID) {
    displayErrorMessage("You must enter a certificate type.");
    return false;
  }

  if (!certificateData.value?.userID) {
    displayErrorMessage("You must enter the Added By field.");
    return false;
  }

  if (!e.validationGroup._validationInfo.result.isValid) {
    return false;
  }

  if (
    certificateTypeData.value.requiresProperty ==
      CertificateTypesValidation.PopertyRequired &&
    !certificateData.value.propertyID
  ) {
    displayErrorMessage("You must link this Certificate to a Property");
    return false;
  }

  if (!certificateData.value.contactID) {
    displayErrorMessage("You must link this Certificate to a Contact");
    return false;
  }

  return true;
};

const saving = ref(false);

/** Handles the Save button click event */
const onSaveClick = async (e: any) => {
  const validate = e.validationGroup.validate();

  if (!validate.isValid) {
    return;
  }

  if (!saveValidation(e)) {
    return;
  }

  saving.value = true;

  if (!(await submitData())) {
    saving.value = false;
    return;
  }

  saving.value = false;
  showCloseConfirmation.value = false;
  emit("modalClosed", true);
  closeCertificateModal();
};

/** Closes the certificate modal */
const closeCertificateModal = () => {
  showCertificateModal.value = false;
};

/** Pushes the updated certificate to the api */
const submitData = async () => {
  if (props.certificateId) {
    return await editCertificate();
  } else {
    return await createCertificate();
  }
};

const createCertificate = async () => {
  try {
    await acquaintApiClient.httpPost(
      `database/certificates`,
      certificateData.value,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    showCloseConfirmation.value = true;
    return false;
  }
};

const editCertificate = async () => {
  try {
    await acquaintApiClient.httpPut(
      `database/certificates/${props.certificateId}`,
      certificateData.value,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    showCloseConfirmation.value = true;
    return false;
  }
};

const certificateTypeData = ref<CertificateTypes>();

const fetchCertificateType = async (certificateTypeId: number) => {
  certificateTypeData.value = await acquaintApiClient.httpGet(
    `database/certificatetypes/${certificateTypeId}`,
  );
};

watch(
  () => certificateData.value?.certificateTypeID,
  async (value, oldValue) => {
    // certificateData is set to undefined everytime the modal is opened and so when the id is changed because certificateData is set initalCertificateData
    // we don't bother calling the certiifcate type API and update the end date
    if (oldValue == undefined) {
      return;
    }

    // There is no point calling the certificate type API if there is no selected certificate type or certificate default data.
    if (
      !certificateData.value ||
      !certificateData.value.certificateTypeID ||
      certificateData.value.certificateTypeID == -1
    ) {
      return;
    }

    await fetchCertificateType(certificateData.value?.certificateTypeID);
    setEndDateByCertificateTypeDuration();
  },
);

const setEndDateByCertificateTypeDuration = () => {
  if (!certificateData.value || !certificateTypeData.value) {
    return;
  }

  certificateData.value.endDate = moment(
    certificateData.value.startDate,
    "YYYY-MM-DD",
  )
    .add(certificateTypeData.value.duration, "months")
    .subtract(1, "days")
    .format("YYYY-MM-DD");
};

const setInitialEndDateByCertificateTypeDuration = () => {
  if (!initalCertificateData.value || !certificateTypeData.value) {
    return;
  }

  initalCertificateData.value.endDate = moment(
    initalCertificateData.value.startDate,
    "YYYY-MM-DD",
  )
    .add(certificateTypeData.value.duration, "months")
    .subtract(1, "days")
    .format("YYYY-MM-DD");
};

const fetchProperty = async (propertyId: number) => {
  try {
    propertyData.value = await acquaintApiClient.httpGet(
      `database/properties/${propertyId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

const setEditableContactId = async (propertyId: number) => {
  await fetchProperty(propertyId);

  if (certificateData.value && propertyData.value) {
    certificateData.value.contactID = propertyData.value.contactID;
  }
};

const setOriginalContactId = async (propertyId: number) => {
  await fetchProperty(propertyId);

  if (initalCertificateData.value && propertyData.value) {
    initalCertificateData.value.contactID = propertyData.value.contactID;
  }
};

watch(
  () => certificateData.value?.propertyID,
  async (value, oldValue) => {
    // If we are opening the modal from the certificates tab in a contact's page, we can't allow the contact id to be changed as the user is creating the
    // certificate for that contatct. We also dont want to set the contact id to the contact of the property when we are opening the modal for a certificate
    // that already has a contact

    if (
      !certificateData.value?.propertyID ||
      certificateData.value?.propertyID == -1 ||
      props.contactId > 0 ||
      (!oldValue && certificateData.value.contactID > 0)
    ) {
      return;
    }

    await setEditableContactId(certificateData.value.propertyID);
  },
);

watch(
  () => certificateData.value,
  () => {
    showCloseConfirmation.value =
      JSON.stringify(certificateData.value) !=
      JSON.stringify(initalCertificateData.value);
  },
  { deep: true },
);

const selectedTab = ref(0);

watch(
  () => certificateData.value?.endDate,
  (value, oldValue) => {
    // After the modal has been opened for certificate, we can't updated the status - this was occasionally happening for certificates and so their statuses
    // were being updated because the certificateData object was being set to the initial object not because the user had changed the end date.
    if (!certificateData.value?.endDate || !oldValue) {
      return;
    }

    const today = moment(new Date()).format("YYYY-MM-DD");

    /* Ensure status is sync'd with the current end date.
     * This maintains data integrity whilst making the screen less confusing for the user */
    if (moment(certificateData.value.endDate).isBefore(today)) {
      certificateData.value.status = CertificateStatus.Expired;
    }

    if (moment(certificateData.value.endDate).isSameOrAfter(today)) {
      certificateData.value.status = CertificateStatus.Current;
    }
  },
);

watch(
  () => certificateData.value?.startDate,
  () => {
    if (!certificateData.value?.startDate) {
      return;
    }

    setEndDateByCertificateTypeDuration();
  },
);

const showRatingsTab = computed(
  () => certificateData.value?.certificateTypeID === CertificateType.EPC,
);

const lockPropertyField = computed(() =>
  props.propertyId > 0 ? true : enableFields.value,
);

const lockContactField = computed(() =>
  props.contactId > 0 ? true : enableFields.value,
);

const onModalClosed = () => {
  keepingModalOpening.value = false;
  emit(
    "modalClosed",
    props.certificateData
      ? JSON.stringify(props.certificateData) !=
          JSON.stringify(initalCertificateData.value)
      : false,
  );
};

const helpPage = computed(() =>
  props.certificateId ? "certificates" : "adding-a-certificate",
);

const issuerType = computed(() => {
  if (!certificateTypeData.value) {
    return LookupTableSource.Contractors;
  }

  switch (certificateTypeData.value.issuerTypeID) {
    case SystemContactTypes.Bank:
      return LookupTableSource.Bank;
    case SystemContactTypes.Contractor:
      return LookupTableSource.Contractors;
    case SystemContactTypes.FinancialAdvisor:
      return LookupTableSource.FinancialAdvisors;
    case SystemContactTypes.InsuranceCompany:
      return LookupTableSource.InsuranceCompanies;
    case SystemContactTypes.LocalAuthority:
      return LookupTableSource.LocalAuthorities;
    case SystemContactTypes.MortgageProvider:
      return LookupTableSource.MortgageProviders;
    case SystemContactTypes.Solicitor:
      return LookupTableSource.Solicitors;
    case SystemContactTypes.UtilitySupplier:
      return LookupTableSource.UtilitySupplier;
    case SystemContactTypes.User:
      return LookupTableSource.Users;
    default:
      return LookupTableSource.Contractors;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showCertificateModal.value,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showCertificateModal).value = $event)),
    title: "Certificate",
    showCloseButton: !saving.value,
    height: "580px",
    showCloseConfirmationPrompt: showCloseConfirmation.value,
    onModalClosed: onModalClosed,
    onCancelPromptDenied: _cache[12] || (_cache[12] = ($event: any) => (keepingModalOpening.value = true)),
    saving: saving.value,
    "help-page": helpPage.value
  }, {
    content: _withCtx(() => [
      (certificateData.value)
        ? (_openBlock(), _createBlock(_unref(DxTabPanel), {
            key: 0,
            "scroll-by-content": true,
            "show-nav-buttons": true,
            "swipe-enabled": false,
            selectedIndex: selectedTab.value,
            "onUpdate:selectedIndex": _cache[10] || (_cache[10] = ($event: any) => ((selectedTab).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxItem), { title: "General" }, {
                default: _withCtx(() => [
                  _createElementVNode("section", _hoisted_1, [
                    _createVNode(lookupSingleSelect, {
                      modelValue: certificateData.value.certificateTypeID,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((certificateData.value.certificateTypeID) = $event)),
                      "lookup-source": _unref(LookupTableSource).CertificateTypes,
                      style: {"width":"22rem"},
                      label: "Type",
                      readOnly: enableFields.value
                    }, null, 8, ["modelValue", "lookup-source", "readOnly"]),
                    _createVNode(PropertyLookup, {
                      label: "Property",
                      modelValue: certificateData.value.propertyID,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((certificateData.value.propertyID) = $event)),
                      readOnly: lockPropertyField.value,
                      displayNavigateIcon: false,
                      displayPeek: true
                    }, null, 8, ["modelValue", "readOnly"]),
                    _createVNode(ContactLookup, {
                      label: "Contact",
                      modelValue: certificateData.value.contactID,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((certificateData.value.contactID) = $event)),
                      readOnly: lockContactField.value,
                      findNameOnIdChange: true,
                      showNavigateContactIcon: false
                    }, null, 8, ["modelValue", "readOnly"]),
                    _createVNode(lookupSingleSelect, {
                      label: "Issuer",
                      modelValue: certificateData.value.issuerID,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((certificateData.value.issuerID) = $event)),
                      "lookup-source": issuerType.value
                    }, null, 8, ["modelValue", "lookup-source"]),
                    _createVNode(AcquaintTextbox, {
                      label: "Reference",
                      modelValue: certificateData.value.reference,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((certificateData.value.reference) = $event)),
                      readOnly: enableFields.value,
                      fieldValidation: _unref(CertificatesValidation).Reference,
                      "validation-group": "new-certificate"
                    }, null, 8, ["modelValue", "readOnly", "fieldValidation"]),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(AcquaintDateBox, {
                        label: "Start Date",
                        modelValue: certificateData.value.startDate,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((certificateData.value.startDate) = $event)),
                        readOnly: enableFields.value,
                        fieldValidation: _unref(CertificatesValidation).StartDate,
                        width: _unref(FieldSize).SmallMedium,
                        "validation-group": "new-certificate"
                      }, null, 8, ["modelValue", "readOnly", "fieldValidation", "width"]),
                      _createVNode(AcquaintDateBox, {
                        label: "Expiry Date",
                        modelValue: certificateData.value.endDate,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((certificateData.value.endDate) = $event)),
                        readOnly: enableFields.value,
                        fieldValidation: _unref(CertificatesValidation).EndDate,
                        width: _unref(FieldSize).SmallMedium,
                        "validation-group": "new-certificate",
                        "min-date": new Date(certificateData.value.startDate)
                      }, null, 8, ["modelValue", "readOnly", "fieldValidation", "width", "min-date"]),
                      _createVNode(SystemCodeSingleSelect, {
                        label: "Status",
                        modelValue: certificateData.value.status,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((certificateData.value.status) = $event)),
                        readOnly: enableFields.value,
                        "code-type": _unref(CodeType).CertificateStatus,
                        width: _unref(FieldSize).SmallMedium
                      }, null, 8, ["modelValue", "readOnly", "code-type", "width"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(DxItem), {
                Title: "Ratings",
                disabled: !showRatingsTab.value
              }, {
                default: _withCtx(() => [
                  (showRatingsTab.value)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                        _createVNode(EpcInputWrapper, {
                          modelValue: certificateData.value,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((certificateData).value = $event)),
                          "property-usage": 
                propertyData.value?.usage ?? _unref(PropertyUsages).Residential
              ,
                          "country-code": propertyData.value?.countryCode ?? _unref(CountryCode).UK,
                          "validation-group": "new-certificate"
                        }, null, 8, ["modelValue", "property-usage", "country-code"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_unref(DxItem), { Title: "System Info" }, {
                default: _withCtx(() => [
                  _createElementVNode("section", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(AcquaintInfoBox, {
                        label: "Date Added",
                        text: _unref(formatDate)(certificateData.value.addedDate, true),
                        width: _unref(FieldSize).Medium
                      }, null, 8, ["text", "width"]),
                      _createVNode(AcquaintInfoBox, {
                        label: "Date Updated",
                        text: _unref(formatDate)(certificateData.value.updatedDate, true),
                        width: _unref(FieldSize).Medium
                      }, null, 8, ["text", "width"]),
                      _createVNode(lookupSingleSelect, {
                        modelValue: certificateData.value.userID,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((certificateData.value.userID) = $event)),
                        "lookup-source": _unref(LookupTableSource).Users,
                        width: _unref(FieldSize).Medium,
                        label: "Added By",
                        readOnly: true
                      }, null, 8, ["modelValue", "lookup-source", "width"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["selectedIndex"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Save',
          onClick: onSaveClick,
          disabled: saving.value,
          validationGroup: 'new-certificate',
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => closeCertificateModal(),
          disabled: saving.value,
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "showCloseButton", "showCloseConfirmationPrompt", "saving", "help-page"]))
}
}

})